import { render, staticRenderFns } from "./PainelAuditoria.vue?vue&type=template&id=53a6cf18"
import script from "./PainelAuditoria.vue?vue&type=script&lang=js"
export * from "./PainelAuditoria.vue?vue&type=script&lang=js"
import style0 from "./PainelAuditoria.vue?vue&type=style&index=0&id=53a6cf18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports